import IMenu from "@/interfaces/IMenu";

/**  Option to remove an entity - by default if will ask for confirmation */
export default function <T>(entityName: string): IMenu<T> {
  return {
    i18nAction: "common.remove",
    requireConfirmation: true,
    name: entityName,
    command: () => undefined,
    icon: "trash-alt",
  };
}
